const formatEWS = (value) => {
	if (!value) return null;

	const regex = /^\d{1,3}(,\d{3})*\.\d{2,3}$/;
	if (regex.test(value)) return value;

	const number = Number(value);
	if (Number.isNaN(number)) return null;
	return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export { formatEWS };
